<template>
    <!-- Footer -->
    <footer class="page-footer center-on-small-only">

        <!-- Footer Links -->
        <div class="container mb-0 pb-0">
            <div class="row">
                <div class="col">
                    <p class="text-center mb-0" v-lang.daff></p>
                </div>
            </div>
        </div>
        <!-- Footer Links -->

        <div class="mt-4 mb-3 text-center">
            <a target="_blank" href="https://daff.tv/" >
                <img class="dafflogo" src="../assets/img/DAFFLOGO_0.png" alt="Logo DAFF" />
            </a>
            &nbsp;
            <a target="_blank" href="https://verband-der-agenturen.de" >
                <img class="vdalogo" src="../assets/img/VdA_Logo_III.jpg" alt="Logo VdA" />
            </a>
        </div>

        <!-- Copyright -->
        <div class="footer-copyright mt-0 pt-0">
            <div class="container-fluid">
                © 2026 Copyright: Heimann.s Agentur &nbsp;
                <a href="#" data-toggle="modal" data-target=".bd-imprint-modal-lg"> Impressum </a>&nbsp;
                <a href="#" data-toggle="modal" data-target=".bd-data-protection-modal-lg"> Datenschutzerklärung </a>
            </div>
        </div>
        <!-- Copyright -->

    </footer>
    <!-- Footer -->
  
</template>

<script>
export default {

}
</script>

<style>

    .dafflogo {
        max-width:200px;
    }
    .vdalogo {
        max-width:162px;
        padding-top:1px;
    }

    footer {
        background: #0188c0;
    }
        
    footer.page-footer .footer-copyright {
        background: inherit;
    }

    @media (max-width: 575px) {
        footer.page-footer .footer-copyright {
            line-height:25px;
            padding-bottom:70px;
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue